/**
 * @file geo.js
 * @description ZIP code geocoding utility using the free zippopotam.us API.
 *   Returns city and state abbreviation for a given US ZIP code.
 * @author Victor Carpinelli
 * @version 1.0.0
 * @module utils/geo
 */
// ─── ZIP code geocoding — free, no API key required ──────────────────────────
// Uses zippopotam.us — returns { city, state } or null on failure.

/**
 * @description Looks up city and state for a US ZIP code using the zippopotam.us API.
 * @param {string} zip - US ZIP code
 * @returns {Promise<{city: string, state: string}|null>} Location data or null on failure
 */
export async function lookupZip(zip) {
  try {
    const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
    if (!res.ok) return null;
    const data = await res.json();
    const place = data.places?.[0];
    if (!place) return null;
    return {
      city:  place["place name"],
      state: place["state abbreviation"],
    };
  } catch {
    return null;
  }
}
